var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout-sider',{staticClass:"sider",attrs:{"width":"200"}},[(['super_admin', 'system_admin'].includes(_vm.roleSlug))?_c('system-layoutSider'):_c('tenant-layoutSider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }